import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box } from '@mui/material';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import customImage from '../../assets/images/1.jpg'

const images = [
  { url: require("../../assets/images/1.jpg"), title: "Image 1" },
  { url: require("../../assets/images/2.jpg"), title: "Image 2" },
  { url: require("../../assets/images/3.jpg"), title: "Image 3" },
  { url: require("../../assets/images/4.jpg"), title: "Image 4" },
  { url: require("../../assets/images/5.jpg"), title: "Image 5" },
  { url: require("../../assets/images/6.jpg"), title: "Image 6" },
];

const SwiperComp = ({ propImages = images }) => {
  return (
    <Box>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: true,
        }}
        loop={true}
        loopFillGroupWithBlank={true}
        loopedSlides={images.length} // Duplicate enough slides for smoother infinite loop
        centeredSlides={true}

        spaceBetween={30}
        slidesPerView={3}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
      >
        {propImages.map((img, index) => (
          <SwiperSlide key={index}>
            <Box sx={{ padding: 1, transition: 'transform 0.3s ease', width:'100%', height:'200px', position:'relative', overflow:'hidden', }}>
              <Box
                component="img"
                src={img.url}
                alt={img.title}
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '12px',
                  // objectFit:'cover',
                  // objectPosition:'center',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)', // Zoom effect on hover
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)', // Subtle shadow on hover
                  },
                  '&:hover::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    borderRadius: 'inherit',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)', // Overlay effect
                  },
                }}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default SwiperComp;
